const AD_QUANTITY = [
  {
    text: '5 anúncios',
    value: 5,
    label: '5',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_5_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_5_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_5_V3',
    },
  },
  {
    text: '10 anúncios',
    value: 10,
    label: '10',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_10_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_10_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_10_V3',
    },
  },
  {
    text: '15 anúncios',
    value: 15,
    label: '15',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_15_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_15_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_15_V3',
    },
  },
  {
    text: '20 anúncios',
    value: 20,
    label: '20',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_20_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_20_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_20_V3',
    },
  },
  {
    text: '30 anúncios',
    value: 30,
    label: '30',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_30_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_30_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_30_V3',
    },
  },
  {
    text: '40 anúncios',
    value: 40,
    label: '40',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_40_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_40_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_40_V3',
    },
  },
  {
    text: '50 anúncios',
    value: 50,
    label: '50',
    bundleTypes: {
      economic: 'BUNDLE_VISIBILITY_AUTOS_ECONOMY_50_V2',
      performance: 'BUNDLE_VISIBILITY_AUTOS_PERFORMANCE_50_V2',
      specialist: 'BUNDLE_VISIBILITY_AUTOS_SPECIALIST_50_V3',
    },
  },
  {
    text: 'Mais de 50 anúncios',
    value: 51,
    label: '50+',
    bundleTypes: {
      economic: '',
      performance: '',
      specialist: '',
    },
  },
];

export default AD_QUANTITY;
